/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from "moment";
import * as types from "./types";

export const state = {
  list: [],
  payment: {},
  filtersInitialDate: moment()
    .startOf("month")
    .format("YYYY-MM-DD"),
  filtersFinalDate: moment()
    .endOf("month")
    .format("YYYY-MM-DD"),
  filtersPaymentInitialDate: moment()
    .startOf("year")
    .format("YYYY-MM-DD"),
  filtersPaymentFinalDate: moment()
    .add(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD"),
  filtersCardBrand: "",
  filtersTerminalNumber: "",
  filtersNsuAcquirer: "",
  filtersStatus: "",
  filtersOperation: "",
  filtersOrdination: "",
  limitOptions: [10, 25, 50, 100],
  totalResources: 0,
  currentPage: 1,
  limit: 10,
  page: 1,
  loadingData: false,
  subtotal: 0,
  filterStatus: false,
  newPayment: [],
  updateSubscription: [],
  newPaymentStatus: false,
  newPaymentError: false,
  showFilters: false,
  filtersPartner: "",
  filtersMinAmount: null,
  filtersMaxAmount: null,
  successStatus: false,
  errorStatus: false,
  errorMessage: "",
  newPaymentResponse: null,
  filterParams: {
    page: 1,
    limit: 10,
    filterrific: {
      with_created_at_between: {
        start_at: null,
        end_at: null,
      },
      status: null,
      credit_card_brand: null,
      with_terminal_number: null,
      operation: null,
      with_partner: null,
      sorted_by: null,
      with_amount_gteq: null,
      with_amount_lteq: null,
    },
    nsu_acquirer_cont: null
  }
};

export const mutations = {
  [types.FILTER_STATUS](state, status) {
    state.filterStatus = status;
  },
  [types.SET_PAYMENTS_SUBTOTAL](state, subtotal) {
    state.subtotal = subtotal;
  },
  [types.SET_PAYMENTS_LIST](state, list) {
    state.list = list;
  },
  [types.SET_PAYMENT_DATA](state, payment) {
    state.payment = payment;
  },
  [types.SET_FILTER_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.SET_FILTER_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.SET_FILTER_PAYMENT_INITIAL_DATE](state, date) {
    state.filtersPaymentInitialDate = date;
  },
  [types.SET_FILTER_PAYMENT_FINAL_DATE](state, date) {
    state.filtersPaymentFinalDate = date;
  },
  [types.SET_FILTER_CARD_BRAND](state, cardBrand) {
    state.filtersCardBrand = cardBrand;
  },
  [types.SET_FILTER_TERMINAL_NUMBER](state, terminalNumber) {
    state.filtersTerminalNumber = terminalNumber;
  },
  [types.SET_FILTER_NSU_ACQUIRER](state, param) {
    state.filtersNsuAcquirer = param;
  },
  [types.SET_FILTER_OPERATION](state, operation) {
    state.filtersOperation = operation;
  },
  [types.SET_FILTER_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SET_FILTER_STATUS](state, status) {
    state.filtersStatus = status;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.SET_TOTAL_RESOURCES](state, total) {
    state.totalResources = total;
  },
  [types.LIMIT_OPTIONS](state, options) {
    state.limitOptions = options;
  },
  [types.LIMIT](state, param) {
    state.limit = param;
  },
  [types.PAGE](state, param) {
    state.page = param;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.NEW_PAYMENT](state, newPayment) {
    state.newPayment = newPayment;
  },
  [types.UPDATE_SUBSCRIPTION](state, updateSubscription) {
    state.updateSubscription = updateSubscription;
  },
  [types.NEW_PAYMENT_STATUS](state, newPaymentStatus) {
    state.newPaymentStatus = newPaymentStatus;
  },
  [types.NEW_PAYMENT_ERROR](state, newPaymentError) {
    state.newPaymentError = newPaymentError;
  },
  [types.SHOW_FILTERS](state, param) {
    state.showFilters = param;
  },
  [types.FILTER_PARAMS](state, param) {
    state.filterParams = param;
  },
  [types.SET_FILTER_PARTNER](state, param) {
    state.filtersPartner = param;
  },
  [types.SET_FILTER_MIN_AMOUNT](state, param) {
    state.filtersMinAmount = param;
  },
  [types.SET_FILTER_MAX_AMOUNT](state, param) {
    state.filtersMaxAmount = param;
  },
  [types.LOAD_LIST](state, list) {
    state.list = list;
  },
  [types.LOAD_LIST_SUBSCRIPTIONS](state, subscriptions) {
    state.list = subscriptions;
  },
  [types.LOAD](state, loading) {
    state.loadingData = loading;
  },
  [types.SUCCESS_STATUS](state, status) {
    state.successStatus = status;
  },
  [types.ERROR_STATUS](state, status) {
    state.errorStatus = status;
  },
  [types.ERROR_MESSAGE](state, message) {
    state.errorMessage = message;
  },
  [types.GET_PAYMENT](state, payment) {
    state.payment = payment;
  },
  [types.NEW_PAYMENT_RESPONSE](state, response) {
    state.newPaymentResponse = response;
  }
};
